import { Stack, Tooltip, Typography } from '@mui/material'
import { CarrierVisitStatus } from '@planning/app/api'
import { CarrierVisitStatusChip } from '@planning/components/CarrierVisitStatusChip'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, InfoIcon, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

type VesselVisitInformationProps = {
  vesselVisitNumber?: string | null
  portCallNumber?: string | null
  voyageNumber?: string[] | null
  operator?: string | null
  agent?: string | null
  vesselService?: string | null
  portRotation?: string | null
  status: CarrierVisitStatus
  isBerthed?: boolean
}

export const VesselVisitInformation = observer((props: VesselVisitInformationProps) => {
  const {
    portCallNumber,
    voyageNumber,
    operator,
    agent,
    vesselService,
    portRotation,
    status,
    isBerthed,
  } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <>
      <Typography variant='body2' color={theme.palette.text.secondary}>
        {t('portCallNumberAbrv', 'Port call no.')}: {portCallNumber ?? EmptyIndicator}
      </Typography>
      <Typography variant='body2' color={theme.palette.text.secondary}>
        {t('voyageNumberAbrv', 'Voyage no.')}:
        {voyageNumber?.length ? voyageNumber.map(voyage => voyage).join('\n') : EmptyIndicator}
      </Typography>
      <Typography variant='body2' color={theme.palette.text.secondary}>
        {t('operatorAgent', 'Operator / Agent')}: {operator ?? EmptyIndicator} /{' '}
        {agent ?? EmptyIndicator}
      </Typography>
      {vesselService ? (
        <Stack direction='row' alignItems='center' spacing={theme.customSpacing.xxxs}>
          <Typography variant='body2' color={theme.palette.text.secondary}>
            {t('vesselService', 'Vessel service.')}: {vesselService ?? EmptyIndicator}
          </Typography>
          <Tooltip sx={{ textOverflow: 'ellipsis', maxWidth: '100px' }} title={portRotation}>
            <InfoIcon sx={{ color: theme.palette.grey[600] }} fontSize='small' />
          </Tooltip>
        </Stack>
      ) : null}

      <CarrierVisitStatusChip status={status} isBerthed={isBerthed} />
    </>
  )
})
